import React from 'react';

const ShyTitleComponent = ({ text }) => {
    if (!text) return null;
    const parts = text.split('[_]');
    return parts.length > 1
        ? <>{parts.map((part, i) => <React.Fragment key={i}>{part}{i < parts.length - 1 && '\u00AD'}</React.Fragment>)}</>
        : <>{text}</>;
}

export default ShyTitleComponent;
